export default {"src":"/_next/static/media/white_floorplan.85aa44c9.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};